import { MainAvailabilityComponent } from "./components/main-availability.component";
import { DetailAvailabilityComponent } from "./components/detail-availability.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'availability',
        component: DetailAvailabilityComponent,
        canActivate: [AuthService]
    },
    {
        path: 'availability/:id',
        component: DetailAvailabilityComponent,
        canActivate: [AuthService]
    }
   
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class AvailabilityRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/availability/availability.routes.ts